import Item from './Item';
import { EVENT_TYPE, GRID } from '@/common/constants';
import { useToolBar } from '@/hooks';
import {
  GETTERS as PRINT_GETTERS,
  MUTATES as PRINT_MUTATES
} from '@/store/modules/print/const';
import {
  GETTERS as APP_GETTERS,
  MUTATES as APP_MUTATES
} from '@/store/modules/app/const';
import { mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    Item
  },
  props: {
    isDigital: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { setToolNameSelected } = useToolBar();
    return {
      setToolNameSelected
    };
  },
  computed: {
    ...mapGetters({
      hideSafeMargin: PRINT_GETTERS.SAFE_MARGIN,
      hideTrimLineBleed: PRINT_GETTERS.TRIM_LINE_BLEED,
      showGrid: APP_GETTERS.SHOW_GRID
    })
  },
  data() {
    const items = [
      {
        name: 'Hide Trim Line/Bleed Area',
        value: GRID.HIDE_TRIM_LINE_BLEED,
        active: false
      },
      {
        name: 'Hide Safe Margin',
        value: GRID.HIDE_SAFE_MARGIN,
        active: false
      },
      {
        name: 'Show Grid',
        value: GRID.SHOW_GRID,
        active: false
      }
    ];
    if (this.isDigital) items.splice(0, 2);
    return { items };
  },
  mounted() {
    this.setToolName();
  },
  methods: {
    ...mapMutations({
      setSafeMargin: PRINT_MUTATES.SET_SAFE_MARGIN,
      setTrimLineBleed: PRINT_MUTATES.SET_TRIM_LINE_BLEED,
      setShowGrid: APP_MUTATES.SET_SHOW_GRID
    }),
    setToolName() {
      if (!this.isDigital) {
        this.items[0].name = this.hideTrimLineBleed
          ? 'Show Trim Line/Bleed Area'
          : 'Hide Trim Line/Bleed Area';
        this.items[1].name = this.hideSafeMargin
          ? 'Show Safe Margin'
          : 'Hide Safe Margin';
        this.items[2].name = this.showGrid ? 'Hide Grid' : 'Show Grid';
      } else this.items[0].name = this.showGrid ? 'Hide Grid' : 'Show Grid';
    },
    onClick(actionValue) {
      if (actionValue === GRID.HIDE_TRIM_LINE_BLEED) {
        this.setTrimLineBleed({ hideTrimLineBleed: !this.hideTrimLineBleed });
      }

      if (actionValue === GRID.HIDE_SAFE_MARGIN) {
        this.setSafeMargin({ hideSafeMargin: !this.hideSafeMargin });
      }

      if (actionValue === GRID.SHOW_GRID) {
        this.setShowGrid({ showGrid: !this.showGrid });
        this.$root.$emit(EVENT_TYPE.SHOW_GRID);
      }

      this.setToolNameSelected({
        name: ''
      });
    }
  }
};
